/**
 * Fixes videojs issue https://github.com/videojs/video.js/issues/4688
 */
export function fixVideojs() {
  setTimeout(() => {
    const font_options = [...document.querySelectorAll('.vjs-font-family option')];

    font_options.forEach(option => {
      const id = option.id;
      const new_id = id.split(' ').join('-');
      const labelledby = option.getAttribute('aria-labelledby');
      const new_labelledby = labelledby.replace(id, new_id);

      option.id = new_id;
      option.setAttribute('aria-labelledby', new_labelledby);
    });
  }, 0);
}
